"use client";
import { Box, GridItem, SimpleGrid, Stack, Highlight } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import PageLayout from "@/layouts/pageLayout";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text, Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";

export type OmsSolutionsProps = {
  title: string;
  desc: { highlight: string | string[]; text: string }[];
  marginTop?: number;
  btnText?: string;
};

const OmsSolutions = (props: OmsSolutionsProps) => {
  const { title, desc, marginTop = 14, btnText = "Talk To Us" } = props;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();

  return (
    <Box
      bgImage="url('/shared/lbBg.png')"
      bgSize="cover"
      p={{ base: 4, md: 12 }}
      mt={marginTop}
    >
      <PageLayout spacing={8} marginTop={12}>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 5 }} gap={{ base: 8, md: 8, lg: 16 }}>
          <GridItem colSpan={{ base: 1, sm: 2, md: 2 }}>
            <Heading as="h2" variant={HeadingVariant}>
              {title}
            </Heading>
          </GridItem>
          <GridItem colSpan={{ base: 1, sm: 2, md: 3 }}>
            <Stack gap={4}>
              {desc.map((item, index) => (
                <Balancer key={index}>
                  <Text key={index} variant={TextVariant} color="text.100">
                    <Highlight
                      styles={{ fontWeight: 600, color: "text.100" }}
                      query={item.highlight}
                    >
                      {item.text}
                    </Highlight>
                  </Text>
                </Balancer>
              ))}
            </Stack>
          </GridItem>
        </SimpleGrid>
        <Button
          onClick={() => scrollToElement("contact-us", 120)}
          variant={"ideal"}
          borderRadius={"full"}
          minW={"150px"}
          alignSelf={"center"}
          mb={{ base: 4, md: 0 }}
        >
          {btnText}
        </Button>
      </PageLayout>
    </Box>
  );
};

export default OmsSolutions;
